<div class="banner" [ngClass]="status()">
  <nb-icon [config]="icon()"></nb-icon>
  <span>{{ message() }}</span>
  <ng-content></ng-content>
</div>
